import { Injectable } from "@angular/core";

export interface StorageInterface {

  ready(): Promise<any>;

  get(key: string): Promise<any>;

  set(key: string, value: any): Promise<any>;
}
@Injectable()
export class StorageInterfaceImpl implements StorageInterface {
  ready(): Promise<any> {
    throw new Error("Method not implemented.");
  }  get(key: string): Promise<any> {
    throw new Error("Method not implemented.");
  }
  set(key: string, value: any): Promise<any> {
    throw new Error("Method not implemented.");
  }


}